import React from 'react';
import { ShiftChangeRequestFragmentFragment } from '../../../../__generated__/graphql';
import FormattedDateTime from '../../../../../../components/datetime/FormattedDateTime';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import { ShiftDisplay } from '../ShiftDisplay';

type Request = ShiftChangeRequestFragmentFragment;

type RequestCardProps = {
  request: Request;
  headerActions: React.ReactNode;
  children?: React.ReactNode;
};

export const RequestCard: React.FC<RequestCardProps> = ({
  request,
  headerActions,
  children,
}) => {
  const t = useNamespacedTranslation('schedulerShifts.shiftChangeRequest');

  return (
    <div key={request.Id} className="border rounded p-3 bg-paper-5">
      <div className="d-flex flex-column gap-2">
        <div className="d-flex align-items-center justify-content-between">
          <span className="fw-semibold">{t('title')}</span>
          {headerActions}
        </div>
        {request.shift?.flair__Start_Datetime__c &&
          request.shift?.flair__End_Datetime__c && (
            <div className="text-muted small">
              <strong>{t('shift')}:</strong>{' '}
              <ShiftDisplay
                title={request.shift.flair__Title__c || ''}
                startDate={request.shift.flair__Start_Datetime__c}
                endDate={request.shift.flair__End_Datetime__c}
              />
            </div>
          )}
        {request.flair__Requested_At__c && (
          <div className="text-muted small">
            <strong>{t('requestedAt')}:</strong>{' '}
            <FormattedDateTime
              dateTime={request.flair__Requested_At__c}
              format="long"
            />
          </div>
        )}
        {request.flair__Change_Reason__c && (
          <div className="text-muted small mt-1">
            <strong>{t('requestReason')}:</strong>{' '}
            {request.flair__Change_Reason__c}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
